__turbopack_context__.v({
  "description": "PowerplugSection-module__zom5RG__description",
  "eyebrow": "PowerplugSection-module__zom5RG__eyebrow",
  "header": "PowerplugSection-module__zom5RG__header",
  "heading": "PowerplugSection-module__zom5RG__heading",
  "phoneImage": "PowerplugSection-module__zom5RG__phoneImage",
  "phoneScreen": "PowerplugSection-module__zom5RG__phoneScreen",
  "phoneWrapper": "PowerplugSection-module__zom5RG__phoneWrapper",
  "screenImageEl": "PowerplugSection-module__zom5RG__screenImageEl",
  "screenVideo": "PowerplugSection-module__zom5RG__screenVideo",
  "section": "PowerplugSection-module__zom5RG__section",
});
